import React, { Fragment } from 'react'
import {
    List, Datagrid, Filter, ShowButton, UrlField,Button, TextInput, TextField, EditButton, BulkDeleteButton, FunctionField, DeleteButton, useRecordContext, Link
} from 'react-admin'


const ListFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        
    </Filter>
)
const ListActionButtons = ({ ...props }) => {
    return (<>
        <BulkDeleteButton {...props} undoable={false}
            confirmTitle="Delete File Record"
            confirmContent={"Are you sure you want to delete this record?"} />
    </>)
}
const ProfileidFiled = (props)=>{
    const record = useRecordContext();  
    return (
    <TextField {...props} component={Link} to={`/user?filter={"q":"${record.profile_id}"}`} onClick={(event)=>event.stopPropagation()} />
  )}


const UserWalletCountList = ({ ...props }) => {

    return (
        <List {...props} title="Microtask" bulkActionButtons={<ListActionButtons />} filters={<ListFilter />} sort={{ field: 'title', order: 'ASC' }}>

            <Datagrid >
            <TextField source="id" />
                <ProfileidFiled source="profile_id" label="Profile Id" />  
                <TextField source='name' label="Name" />
                <TextField source="userwallet" label="User Wallet" />
                <TextField source="videowallet" label="Video Wallet" />
                <TextField source='transferwallet' label="Transfer Wallet" />
                <TextField source='total_earned' label="Old Withdraw amount" />
                <TextField source='currentwithdrawamount' label="Current Withdraw amount" />
                <TextField source='welcombonus' label="welcome bonus Wallet" />                
                <TextField source='total' label="Total amount" />
            </Datagrid>

        </List>
    )
}


export default UserWalletCountList